import React from "react";
import "./styles.scss";
import { BannerTagline } from "molecules";
import { PurchaseButton } from "atoms";
import { TEXTS } from "../../constants";

export default props => (
  <div className="banner-container">
    <div className="banner">
      <BannerTagline text={TEXTS.TITLE || ""} center />
      <PurchaseButton onClick={props.onButtonClicked} />
    </div>
  </div>
);
